import defu from 'defu'
import { refreshCookie, type UseFetchOptions } from 'nuxt/app'
import type { RuntimeConfig } from 'nuxt/schema'

export const useApi = <T>(url: string | (() => string), options: UseFetchOptions<T> = {}) => {
  const { $store, $auth } = useNuxtApp()
  //const errorStore = useErrorStore()
  const config: RuntimeConfig = useRuntimeConfig()

  const router = useRouter()

  const defaults: UseFetchOptions<T> = {
    baseURL: `${config.public.API_URL}/v1`,
    retry: 1,
    retryStatusCodes: [401],
    retryDelay: 500,
    watch: false,
    deep: false,
    onRequest({ options }) {
      const token = useCookie('auth._token.oidc')

      if ($auth.loggedIn) {
        options.headers = {
          ...options.headers,
          Authorization: token.value,
          Accept: 'application/json',
          'Cache-Control': 'no-cache',
        }
      }
    },
    onResponse: async response => {
      if (response.response.status === 401) {
        console.log('Refreshing token...')

        try {
          await $auth.refreshTokens()
        } catch (e) {
          console.error(e)

          // If refresh token is not successful, logout user and redirect to login page
          if ($auth.$state.loggedIn) await $auth.logout()
          await router.push('/login')
          return
        }

        refreshCookie('auth._token.oidc')
      }
      if (response.response.status === 400) {
        throw new Error(response?.response?._data?.Message ?? 'Bad request')
      }

      return response
    },
    onResponseError({ request, response, options }) {
      if (response.status === 422) {
        const responseErrors = response?._data?.errors
        console.error('Validation error', responseErrors)
        $store.dispatch('validation/setErrors', responseErrors)
        throw new Error('Validation error')
      }
      /*if (Object.hasOwn(error.response._data, 'Message') && !errorStore.hasGlobalError(error.response._data.Message)) {
        errorStore.addGlobalError(error.response._data.Message)
      }*/
      throw new Error(`Request error: ${response.statusText} (${response.status})`)
    },
  }

  return useFetch(url, defu(options, defaults))
}
